import './style.sass';

import React, { Component } from 'react';

import RubricItem from '../rubric-item';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonUsualText from '../../../common-components/common-usual-text';

const rubrics = [
    {
        text: 'Важное для бизнеса — 24',
        bgColor: '#EBF3FF',
    },
    {
        text: 'Полезное для бизнеса — 38',
        bgColor: '#F2F9E3',
    },
    {
        text: 'Управление процессами —11',
        bgColor: '#F6E9FC',
    },
    {
        text: 'HR-взаимодействие — 11',
        bgColor: '#FFF5EB',
    },
    {
        text: 'История поддержки — 20',
        bgColor: '#EEEBFF',
    },
    {
        text: 'Продуктовые посты — 18',
        bgColor: '#FFEBF0',
    },
    {
        text: 'События/Новости — 32',
        bgColor: '#E0F9FB',
    },
    {
        text: 'Анонсы вебинаров/сессий — 23',
        bgColor: '#EFEFEF',
    },
    {
        text: 'Ситуативные посты — 7',
        bgColor: '#EBFFEF',
    },
];

class Process extends Component {
    render() {
        return (
            <div className="garant-fond-process">
                <div className="garant-fond-process__inner">
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                    >
                        <div className="garant-fond-process__wrapper">
                            <CommonTitle className="garant-fond-process__title">
                                Процесс
                            </CommonTitle>
                            <div className="garant-fond-process__col-8 mb-120">
                                <div className="garant-fond-process__container">
                                    <CommonUsualText className="garant-fond-process__text">
                                        Основная задача по этому проекту — охват и привлечение новой
                                        аудитории в группы и увеличение узнаваемости продуктов Фонда
                                        у целевой аудитории. Решили делать это за счет инструментов
                                        контент-маркетинга с точечным подключением таргетинга и
                                        контекста. <br />
                                        <br />
                                        Для каналов Гарантийного фонда определили позиционирование —
                                        источник полезной информации для начинающих
                                        предпринимателей, самозанятых, представителей МСБ.
                                    </CommonUsualText>
                                </div>
                            </div>
                            <div className="garant-fond-process__col-8">
                                <div className="garant-fond-process__container mb-120">
                                    <div className="garant-fond-process__subtitle">
                                        Визуальное обновление
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text">
                                        Разработали новый фирменный стиль для визуального единства
                                        во всех каналах коммуникаций. На его основе подготовили
                                        шаблоны макетов для разных рубрик.
                                    </CommonUsualText>
                                    <div className="garant-fond-process-pic">
                                        <div className="garant-fond-process-pic__item">
                                            <img
                                                src="/images/pic/garant-fond/001.jpg"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="garant-fond-process-pic__item">
                                            <img
                                                src="/images/pic/garant-fond/002.jpg"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                        <div className="garant-fond-process-pic__item">
                                            <img
                                                src="/images/pic/garant-fond/003.jpg"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text">
                                        Сделали апгрейд визуального оформления сообщества в
                                        социальной сети «ВКонтакте» и группы в «Одноклассниках» в
                                        фирменных цветах Гарантийного фонда.
                                    </CommonUsualText>
                                    <div className="garant-fond-process-pic">
                                        <div className="garant-fond-process-pic__item--full">
                                            <img
                                                src="/images/pic/garant-fond/004.jpg"
                                                alt=""
                                                loading="lazy"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="garant-fond-process__subtitle">Контент</div>
                            <div className="garant-fond-process__grid">
                                <div className="garant-fond-process__left">
                                    <CommonUsualText className="garant-fond-process__text">
                                        Посты в аккаунтах должны соответствовать интересам целевой
                                        аудитории, поэтому первично проанализировали её, составили
                                        портреты, определили интересы и боли. Аккаунты Гарантийного
                                        фонда должны стать полезным ресурсом для предпринимателей и
                                        точкой взаимодействия с ними. На основе этого анализа
                                        разработали для Гарантийного фонда контент-план и общие
                                        правила коммуникации (TоV). <br />
                                        <br />
                                        Проанализировав текущий контент, решили дополнить его
                                        полезными форматами и темами, так как именно они привлекают
                                        подписчиков. Это вопросы построения и управления
                                        бизнес-процессами, HR-аспекты.
                                    </CommonUsualText>
                                </div>
                                <div className="garant-fond-process__right">
                                    <div className="garant-fond-process__quote">
                                        <CommonUsualText className="garant-fond-process__text">
                                            <b>По плану посты должны выходить каждый день:</b> и в
                                            выходные, и в праздничные. С этим связан основной вызов
                                            проекта: постоянная генерация идей и тем для контента.
                                        </CommonUsualText>
                                    </div>
                                </div>
                            </div>
                            <div className="garant-fond-process__col-8">
                                <CommonUsualText className="garant-fond-process__text ">
                                    <div className="garant-fond-process__small-title">
                                        Продуктовые посты переформатировали в карточки
                                    </div>
                                    Карточный формат лучше транслирует информацию о формах
                                    поддержки, которые предлагает Фонд.
                                </CommonUsualText>
                                <div className="garant-fond-process-pic">
                                    <div className="garant-fond-process-pic__item--half">
                                        <img
                                            src="/images/pic/garant-fond/005.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="garant-fond-process-pic__item--half">
                                        <img
                                            src="/images/pic/garant-fond/006.jpg"
                                            alt=""
                                            loading="lazy"
                                        />
                                    </div>
                                </div>
                                <CommonUsualText className="garant-fond-process__text mt-120">
                                    <div className="garant-fond-process__small-title">
                                        Разработали новый рубрикатор
                                    </div>
                                </CommonUsualText>
                                <div className="garant-fond-process-rubric">
                                    {rubrics.map(item => (
                                        <RubricItem
                                            key={item}
                                            bgColor={item.bgColor}
                                            text={item.text}
                                        />
                                    ))}
                                </div>
                                <CommonUsualText className="garant-fond-process__text ">
                                    <div className="garant-fond-process__small-title">
                                        Контент для всех каналов коммуникаций был одинаковый, но
                                        предпочтения у аудиторий в разных соцсетях отличаются.
                                    </div>
                                </CommonUsualText>
                                <div className="garant-fond-process-socials">
                                    <div className="garant-fond-process-socials__title">
                                        <img
                                            src="/images/pic/garant-fond/vk.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Вконтакте
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text ">
                                        В сообществе «ВКонтакте» максимальное внимание получили
                                        полезные посты о том, как арендовать помещение для бизнеса и
                                        о специфике ведения бизнеса самозанятыми гражданами.
                                    </CommonUsualText>
                                </div>
                                <div className="garant-fond-process-socials">
                                    <div className="garant-fond-process-socials__title">
                                        <img
                                            src="/images/pic/garant-fond/ok.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Одноклассники
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text ">
                                        В «Одноклассниках» в топ по вовлечению попал пост про
                                        историю поддержки малого предприятия из Таганрога и его опыт
                                        взаимодействия с Гарантийным фондом. А вот советы, как
                                        сохранить спрос в кризис, не были восприняты подписчиками
                                        группы в этой соцсети.
                                    </CommonUsualText>
                                </div>
                                <div className="garant-fond-process-socials">
                                    <div className="garant-fond-process-socials__title">
                                        <img
                                            src="/images/pic/garant-fond/tg.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Telegram
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text ">
                                        В Телеграм-канале максимальный охват получили карточки с
                                        принципами клиентоориентированности и истории поддержки
                                        предпринимателей.
                                    </CommonUsualText>
                                </div>
                                <div className="garant-fond-process-socials">
                                    <div className="garant-fond-process-socials__title">
                                        <img
                                            src="/images/pic/garant-fond/dz.svg"
                                            alt=""
                                            loading="lazy"
                                        />
                                        Дзен
                                    </div>
                                    <CommonUsualText className="garant-fond-process__text ">
                                        Реальные кейсы предпринимателей также интересовали аудиторию
                                        Дзен-канала. Но больше всего охвата и дочитываний у
                                        публикаций на тему управления процессами, развития кадров и
                                        мотивации.
                                    </CommonUsualText>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            </div>
        );
    }
}

export default Process;
